export default "__VITE_ASSET__niwWL64i__"